import   MainStyle                  from "components/UI/main.module.scss";
import  React, { useState, useEffect } from 'react';
import { q3x_FunData, GetLabel }    from "Utilities/utils";
import {InputGeneral}               from "components/Field/field";
import { Select }                   from "antd";
import {GetSeferData}               from "SeferPetach/GetData";

let appLang                   = null;

async function getUserHelp(data) {
    var payload = await GetSeferData("usf7", {...data});
    return (payload);
}

const DropdownList = ({
    className,
    style,
    onChange,
    onSearch,
    listOfItems,
    placeholder,
    id,
    name,
    defaultValue,
    title,
    popupClassName,
    value,
    dropdownStyle,
  }) => {
    return (
      <Select
        showSearch
        allowClear
        id={id}
        name={name}
        value={value} // use directly from props
        placeholder={placeholder}
        className={className}
        style={style}
        title={title}
        popupClassName={popupClassName}
        options={listOfItems}
        optionFilterProp="label"
        filterOption={(input, option) =>
          (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
        }
        onChange={(val, option) => {
          onChange?.(val, option); // lift change to parent
        }}
        onSearch={(val) => {
          onSearch?.(val);
        }}
        notFoundContent={null}
        dropdownStyle={dropdownStyle}
      />
    );
};
const Content = ({messageObj, handleChange}) => {
  return(
    <div className={MainStyle.m_3}>
      <CartisanYSpace>
        <span className={[MainStyle.text_body, MainStyle.fs_7,  MainStyle.text_wrap, MainStyle.fw_semibold].join(" ")} >
          {GetLabel(appLang, 592)}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <span className={[MainStyle.text_body, MainStyle.fs_8, MainStyle.text_wrap].join(" ")} >
          {GetLabel(appLang, 593)}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <span className={[MainStyle.text_body, MainStyle.fs_8, MainStyle.text_wrap].join(" ")} >
          {GetLabel(appLang, 594)}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <DropdownList
            value={messageObj.CATEGORY > 0 ? parseInt(messageObj.CATEGORY) : null}
            placeholder={""}                                
            listOfItems={[{value: 1, label: GetLabel(appLang, 596)},{value: 2, label: GetLabel(appLang, 597)}]}
            style={{ width: "100%" }}  
            className={MainStyle.antd_custom_select}                               
            popupClassName={MainStyle.antd_custom_select}                              
            onChange={(event) => handleChange({CATEGORY: (event)})}
            dropdownStyle={{ zIndex: 999999 }}
        />
      </CartisanYSpace>    
      <CartisanYSpace>
        <span className={[MainStyle.text_body, MainStyle.fs_8, MainStyle.text_wrap].join(" ")} >
          {GetLabel(appLang, 595)}
        </span>
      </CartisanYSpace>
      <CartisanYSpace>
        <InputGeneral 
            autoSize={true}
            value={messageObj.DATA}
            className={[MainStyle.fs_6, MainStyle.text_input, MainStyle.border_1].join(" ")} 
            onChange={(event) => handleChange({DATA: q3x_FunData(event.target.value)})}
            maxLength={500}
        />
      </CartisanYSpace>
  </div>
  );
};
const CartisanYSpace  = ({children}) => {
  return(
    <div className={MainStyle.my_2}>
      {children}
    </div>
  );
};

export const HelpModal = () => {
  const [ expanded,   setExpanded]       = useState(false);
  const [ height,     setHeight]         = useState(0);
  const [ overFlow,   setOverFlow]       = useState("hidden");
  const [ messageObj, setMessageObj]     = useState({CATEGORY: null, DATA: ""});
  const [ sended,     setSended]         = useState(false);

  const handleChange = (updatedValues) => {
      const mergedValues = {
          ...messageObj,
          ...updatedValues
      };
      setMessageObj(mergedValues);
  };
  const toggleExpand = () => {
    if (expanded) {
        setExpanded(false);
        setHeight(0); 
        setOverFlow("hidden");
    } else {
        setExpanded(true);
        setHeight(45);
        setOverFlow("scroll");
    }
  };
  const NewRequest = () => {
    try {
        setMessageObj({CATEGORY: null, DATA: ""});
        setSended(false);
    }
    catch(err) {          
      console.error(err);
    }    
  };
  const fetchHelpData = async () => {
    try {
      let data = await getUserHelp(messageObj);
      if (data) {
          if (data?.status?.statusCode == 0) {
            setSended(true);
          }
      }
    }
    catch(err) {          
      console.error(err);
    }
  };

  return (
    <React.Fragment>
      <div style={{ position: 'absolute', bottom: '0px', zIndex: '10000'}}>
        <div className={MainStyle.d_flex}>
            <div  className={[MainStyle.rounded_top_3, MainStyle.bg_theme, MainStyle.border, MainStyle.shadow_sm].join(" ")}>
              <div  onClick={() => {toggleExpand();}} className={[MainStyle.m_2, MainStyle.clickable].join(" ")}>
                <span className={[MainStyle.text_body, MainStyle.fs_6].join(" ")} >
                  {GetLabel(appLang, 591)}
                </span>
              </div>
            </div>
        </div>
        <div
              className={[
                MainStyle.d_flex,
                MainStyle.bg_theme,
                MainStyle.justify_content_start,
                expanded ? MainStyle.border_end : "",
                expanded ? MainStyle.border_top : ""
              ].join(" ")}
        >
          <div  
                style={{
                    height: `${Math.floor(height / 2.0)}rem`,
                    overflowY: `${overFlow}`,
                    transition: 'height 0.1s linear',
                    width: '20rem'
                  }}
          >            
            {!sended && (
              <React.Fragment>
                <Content messageObj={messageObj} handleChange={handleChange}/>
                <CartisanYSpace>
                    <div className={[MainStyle.row].join(" ")}>
                        <div className={[MainStyle.col_2].join(" ")}/>
                        <div className={[MainStyle.col_10].join(" ")}>
                          <button
                            style={{width: '80%'}}
                            className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_7, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                            onClick={() => {fetchHelpData()}}
                          >
                            {GetLabel(appLang, 565)}
                          </button>
                        </div>
                        <div className={[MainStyle.col_2].join(" ")}/>
                    </div>
                </CartisanYSpace>
              </React.Fragment>
            )}
            {sended && (
              <React.Fragment>
                <div className={MainStyle.m_3}>
                  <CartisanYSpace>
                    <span className={[MainStyle.text_body, MainStyle.fs_7,  MainStyle.text_wrap, MainStyle.fw_semibold].join(" ")} >
                      {GetLabel(appLang, 598)}
                    </span>
                  </CartisanYSpace>
                  <CartisanYSpace>
                    <span className={[MainStyle.text_body, MainStyle.fs_7,  MainStyle.text_wrap].join(" ")} >
                      {GetLabel(appLang, 599)}
                    </span>
                  </CartisanYSpace>
                </div>
                <CartisanYSpace>
                    <div className={[MainStyle.row].join(" ")}>
                        <div className={[MainStyle.col_2].join(" ")}/>
                        <div className={[MainStyle.col_10].join(" ")}>
                          <button
                            style={{width: '80%'}}
                            className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_7, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                            onClick={() => {toggleExpand();}}
                          >
                            {GetLabel(appLang, 16)}
                          </button>
                        </div>
                        <div className={[MainStyle.col_2].join(" ")}/>
                    </div>
                </CartisanYSpace>
                <CartisanYSpace>
                    <div className={[MainStyle.row].join(" ")}>
                        <div className={[MainStyle.col_2].join(" ")}/>
                        <div className={[MainStyle.col_10].join(" ")}>
                          <button
                            style={{width: '80%'}}
                            className={[MainStyle.btn_blue, MainStyle.rounded_3, MainStyle.border, MainStyle.shadow_sm, MainStyle.fs_7, MainStyle.text_white, MainStyle.py_3, MainStyle.px_3].join(" ")}
                            onClick={() => {NewRequest();}}
                          >
                            {GetLabel(appLang, 120)}
                          </button>
                        </div>
                        <div className={[MainStyle.col_2].join(" ")}/>
                    </div>
                </CartisanYSpace>                
              </React.Fragment>
            )}
          </div>
        </div>        
      </div>
    </React.Fragment>
  );

};

